var initialResults = document.querySelector('.predictive-search__initial-results');

class PredictiveSearch extends HTMLElement {
constructor() {
    super();

  this.input = this.querySelector('input[type="search"]');
  this.loading = this.querySelector('.ps-loader__container');
    this.predictiveSearchResults = this.querySelector('#predictive-search');

    this.input.addEventListener('input', this.debounce((event) => {
    this.onChange(event);
    }, 200).bind(this));
}

onChange() {
    const searchTerm = this.input.value.trim();

    initialResults.style.display = "none"

    if (!searchTerm.length) {
    this.close();
    initialResults.style.display = "block"
    return;
    }

    this.getSearchResults(searchTerm);

}

getSearchResults(searchTerm) {
  this.loading.style.display = "block";
    fetch(`/search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=4&section_id=predictive-search`)
      .then((response) => {
      
        if (!response.ok) {
        var error = new Error(response.status);
        this.close();
        throw error;
        }
        this.loading.style.display = "none";
        return response.text();
    })
    .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
    })
    .catch((error) => {
        this.close();
        throw error;
    });
}

open() {
    this.predictiveSearchResults.style.display = 'block';
}

close() {
    this.predictiveSearchResults.style.display = 'none';
}

debounce(fn, wait) {
    let t;
    return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
    };
}
}

customElements.define('predictive-search', PredictiveSearch);